import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=518fea0b&scoped=true"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518fea0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518fea0b')) {
      api.createRecord('518fea0b', component.options)
    } else {
      api.reload('518fea0b', component.options)
    }
    module.hot.accept("./supplier.vue?vue&type=template&id=518fea0b&scoped=true", function () {
      api.rerender('518fea0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcPurchaseQty/supplier.vue"
export default component.exports